import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from './../../../shared/services/courier.service';
import { GetClientListRequest, GetClientListResponse, GetRegionRequest, GetRegionResponse, GetRoutesRequest, GetRoutesResponse, GetUsersDefaultClientRequest } from './../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';

@Component({
  templateUrl: 'pick-client.component.html',
  styleUrls: ['./pick-client.component.scss']
})
export class PickClientComponent implements OnInit {

  clientListResponse: GetClientListResponse | null = null;
  regionResponse: GetRegionResponse | null = null;
  routeResponse: GetRoutesResponse | null = null;
  loading: boolean = true;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadClientList();
  }
  
  loadClientList() {
    this.loading = true;
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (!startNewVoucherData) {
      this.router.navigate(['/pick-car']);
      return;
    }
  
    this.courierService.getUsersDefaultClient({} as GetUsersDefaultClientRequest).subscribe(clientResponse => {
      let defaultId = clientResponse.client?.[0]?.clientId;
      if (defaultId === null || defaultId === undefined) {
        console.warn('Default client ID is null or undefined');
      }
  
      this.courierService.getClientList({ clientId: defaultId } as GetClientListRequest).subscribe(clientListResponse => {
        this.clientListResponse = clientListResponse;
        if (clientListResponse === null || clientListResponse === undefined) {
          console.warn('Client list response is null or undefined');
        }
  
        this.loading = false;
      }, error => {
        console.error('Error fetching client list:', error);
        this.loading = false;
      });
    }, error => {
      console.error('Error fetching default client:', error);
      this.loading = false;
    });
  }

  continueNextStep(clientId: number | undefined) {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      startNewVoucherData.clientId = clientId;
      this.courierService.getRegionValue({ clientId } as GetRegionRequest).subscribe(regionResponse => {
        this.regionResponse = regionResponse;
        if (regionResponse.regionList?.length > 0) {
          this.router.navigate(['/pick-region']);
        } else {
          startNewVoucherData.regionId = undefined;
          const routeRequest: GetRoutesRequest = { clientId };
          this.courierService.getRoute(routeRequest).subscribe(routeResponse => {
            this.routeResponse = routeResponse;
            if (routeResponse.routes?.length > 0) {
              this.router.navigate(['/pick-route']);
            } else {
              this.router.navigate(['/checklist']);
            }
          });
        }
      });
    }
  }

  navigateToRulesCheck() {
    this.router.navigate(['/rule-check']);
  }
}